<!--
  --
  -- ご利用日程ページ
  --
  -->
<template>
  <c-container form>
    <c-book-header>ご利用日程</c-book-header>

    <c-book-summary-sheet/>

    <c-form card-style
      v-model="valid"
      @submit="onSubmit"
    >
      <v-card-text>
        <c-time-select
          label="出発日時"
          v-model="begin"
          :dates="calendar.dates"
          :allow="allowBegin"
          :rules="[ruleBegin]"
          :dateDisabled="dateDisabled"
          @change="onChangeBegin"
        />

        <c-time-select
          label="帰着日時"
          v-model="end"
          :dates="calendar.dates"
          :allow="allowEnd"
          :rules="[ruleEnd]"
          :dateDisabled="dateDisabled"
        />

      </v-card-text>

      <!-- メッセージ -->
      <v-card-text v-show="message">
        <p style="font-size: 1.0rem;color: red;">
          {{message}}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <span
          class="openReady"
          v-show="openReady"
        >
          現在オープン予定のため予約できません
        </span>

        <v-btn
          color="primary" type="submit"
          :loading="running"
          :disabled="!valid || running || openReady"
        >
          次へ
        </v-btn>
      </v-card-actions>

    </c-form>
  </c-container>
</template>

<style lang="scss">
.openReady {
  font-size: 0.8rem;
  color: red;
  margin-right: 24px;
}
</style>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CBookSummarySheet from '@/pages/book/components/CBookSummarySheet'
import CForm from '@/components/CForm'
import CTimeSelect from './CTimeSelect'

import { run } from '@/libs/a'
import * as C from '@/consts'
import * as http from '@/libs/http'

export default {
  name: 'Period',
  mixins: [
    page('ご利用日程')
  ],
  components: {
    CBookHeader,
    CBookSummarySheet,
    CForm,
    CTimeSelect
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    const stationID = to.params.stid - 0

    // 予約情報が初期化されていなければ、初期化する
    if (!store.getters['book/initialized']) {
      await store.dispatch('book/init', { stationID })
    }

    // カレンダーをストアから取得し、setData() に渡す
    const calendar = await store.getters['book/calendar']()

    // 出発, 帰着日時の値を得る
    let schedule = store.getters['book/schedule']

    switch (schedule.status) {
      case C.INPUT_RESOLVED:
        break
      case C.INPUT_PENDING:
        // schedule が入力中なら、開始日付で初期値を得る
        schedule = calendar.getDefaultSchedule(schedule.begin)
        break
      default:
        // schedule が未設定なら、calendar.allow の初日で初期値を得る
        schedule = calendar.getDefaultSchedule()
        break
    }

    // 出発, 帰着日時の値を設定する
    this.begin = schedule.begin
    this.end = schedule.end

    return {
      calendar,
      schedule
    }
  },

  props: {
    calendar: Object,
    schedule: Object
  },

  data () {
    return {
      // 出発日時
      begin: this.schedule.begin,

      // 帰着日時
      end: this.schedule.end,

      // フォームのバリデーション状態
      valid: true,

      // メッセージ
      message: '',

      // 処理中
      running: false
    }
  },

  computed: {
    /**
     * 日付の入力可否
     */
    dateDisabled () {
      // 出発, 帰着日時の値を得る
      let dateDisabled = false

      // 日付の修正可否
      if (this.schedule.refer === 'car') {
        dateDisabled = true
      }

      return dateDisabled
    },

    /**
     * 出発日時の入力可能範囲を返す
     */
    allowBegin () {
      return this.calendar.getAllowBegin()
    },

    /**
     * 帰着日時の入力可能範囲を返す
     */
    allowEnd () {
      return this.calendar.getAllowEnd(this.begin)
    },

    /**
     * オープン予定
     */
    openReady (store) {
      let status = false
      const openFlg = store.getters['org/openFlg']
      if (openFlg === 2) {
        status = true
      }
      return status
    }
  },

  methods: {
    ruleBegin (value) {
      // 出発日時の入力範囲を取得する
      const allow = this.allowBegin
      if (allow.begin <= value && value <= allow.end) {
        return true
      }
      return `出発日時は ${allow.begin}〜${allow.end} を指定できます`
    },

    ruleEnd (value) {
      // 帰着日時の入力範囲を取得する
      const allow = this.allowEnd
      if (allow.begin <= value && value <= allow.end) {
        return true
      }
      return `帰着日時は ${allow.begin}〜${allow.end} を指定できます`
    },

    onChangeBegin (value) {
      // 帰着日時 が帰着日時の入力範囲から外れたら自動修正する
      if (this.end < this.allowEnd.begin) {
        this.end = this.allowEnd.begin
      } else if (this.allowEnd.end < this.end) {
        this.end = this.allowEnd.end
      }
    },

    onSubmit () {
      run(async () => {
        this.message = ''
        const resp = await this.dispatch('book/setSchedule', { begin: this.begin, end: this.end })

        if (resp.status === http.OK) {
        } else {
          // this.message = 'ご選択の車両に他予約が入っています\n車両を選択し直してください'
          this.message = resp.data.reasons
          this.valid = false
          console.log(resp.data)
          return
        }

        if (this.getters['book/choosedCar']) {
          this.goTo({ name: 'book/options' })
        } else {
          this.goTo({ name: 'book/car' })
        }
      })
    }
  }
}
</script>
